import React from 'react';
import { Icon } from 'src/components/Icons';
import { CloseBtn } from './CloseButton.styles';
import { t } from 'i18next';

interface ICloseButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  color?: 'red' | 'darkBlue';
}

const CloseButton = (props: ICloseButton) => {
  return (
    <CloseBtn {...props} data-testid="close-btn">
      <Icon type="delete" aria-label={t('Close')} />
    </CloseBtn>
  );
};

export default CloseButton;
